"use strict";
exports.__esModule = true;
exports.PLATFORM_VERSION = void 0;
exports.PLATFORM_VERSION = "1.1.0";
//# sourceMappingURL=constants.js.map